import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [{
		path: '*',
		redirect: '/'
	}, {
		path: '/',
		name: 'PageView',
		component: resolve => require(['@/view/PageView'], resolve),
		children: [{
				path: '/',
				redirect: '/home'
			}, {
				path: '/home',
				name: 'home',
				component: resolve => require(['@/view/HomePage'], resolve),
				meta: {
					title: '首页'
				}
			}, {
				path: '/headset',
				name: 'headset',
				component: resolve => require(['@/view/headset'], resolve),
				meta: {
					title: '耳机详情'
				},
			}, {
				path: '/tablet',
				name: 'tablet',
				component: resolve => require(['@/view/tablet'], resolve),
				meta: {
					title: '平板详情'
				}
			}, {
				path: '/watch',
				name: 'watch',
				component: resolve => require(['@/view/watch'], resolve),
				meta: {
					title: '手表详情'
				}
			}, {
				path: '/companyintroduction',
				name: 'companyintroduction',
				component: resolve => require(['@/view/CompanyIntroduction'], resolve),
				meta: {
					title: '公司介绍'
				}
			}, {
				path: '/phone',
				name: 'phone',
				component: resolve => require(['@/view/phone'], resolve),
				meta: {
					title: '手机详情'
				}
			}, {
				path: '/eyeDevice',
				name: 'eyeDevice',
				component: resolve => require(['@/view/eyeDevice'], resolve),
				meta: {
					title: '护眼仪详情'
				}
			},
			{
				path: '/hairdrier',
				name: 'hairdrier',
				component: resolve => require(['@/view/hairdrier'], resolve),
				meta: {
					title: '吹风机详情'
				}
			}
		]
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js